import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useSEO } from "@/hooks/useSEO";

const AuthCallback = () => {
  useSEO({
    title: "Signing in… | Loch Ness Story",
    description: "Completing authentication.",
    canonical: "/auth/callback",
    noindex: true,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { error } = await supabase.auth.getSession();
        if (error) throw error;
        navigate("/");
      } catch (error) {
        console.error("Error during auth callback:", error);
        navigate("/");
      }
    };

    handleCallback();
  }, [navigate]);

  return <div>Processing login...</div>;
};

export default AuthCallback;